/**
 * Wicked Diesel - Main Theme JS
 */

document.addEventListener('DOMContentLoaded', function () {

    // ==========================================
    // MOBILE NAVIGATION
    // ==========================================
    const mobileToggle = document.querySelector('.header__mobile-toggle');
    const mobileNav = document.querySelector('#mobile-nav');
    const mobileClose = document.querySelector('.mobile-nav__close');
    const mobileOverlay = document.querySelector('.mobile-nav__overlay');

    if (mobileToggle && mobileNav) {
        const openMenu = () => {
            mobileNav.classList.add('is-active');
            mobileNav.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden'; // Prevent scroll
        };

        const closeMenu = () => {
            mobileNav.classList.remove('is-active');
            mobileNav.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = ''; // Restore scroll
        };

        mobileToggle.addEventListener('click', openMenu);

        if (mobileClose) mobileClose.addEventListener('click', closeMenu);
        if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);

        // Escape key close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && mobileNav.classList.contains('is-active')) {
                closeMenu();
            }
        });
    }

    // ==========================================
    // STICKY HEADER SCROLL EFFECT
    // ==========================================
    let lastScroll = 0;
    const header = document.querySelector('.header');

    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll > 100) {
            header.classList.add('header--scrolled');
        } else {
            header.classList.remove('header--scrolled');
        }
        lastScroll = currentScroll;
    });

});

// ==========================================
// PREDICTIVE SEARCH (BASIC OVERRIDE IF NEEDED)
// ==========================================
// Note: predictive-search.js handles the heavy lifting
